const PATH = "/api/v1/profile";

const ENDPOINTS = {
  PROFILE_ME: "/me/",
  PROFILE_ASSETS: "/me/assets/",
  PROFILE_SEED: "/seed/",
  PROFILE_LOCATIONS: "/locations/",
  PROFILE_LOCATIONS_COUNTRY: "/locations/country/",
  PROFILE_LOCATIONS_STATE: "/locations/state/",
  PROFILE_LOCATIONS_CITY: "/locations/city/",
  PROFILE_SUPPORT_DELETE: "/support/delete/",
};

export type ProfileEndpoints = keyof typeof ENDPOINTS;
export const ProfileCollection = { PATH, ENDPOINTS };
